var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"language-select",attrs:{"size":"small"},on:{"change":_vm.setLanguage},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}},[_c('el-option',{attrs:{"label":"English","value":"en"}}),_c('el-option',{attrs:{"label":"中文","value":"cn"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }